import { registerNodeType } from '../../registry'
import { ICONIFY } from '../../../../../Constants/iconify'
import DropdownNode from './DropdownNode'
import DropdownConfig from './DropdownConfig'

registerNodeType({
  type: 'DROPDOWN',
  label: 'Dropdown',
  icon: ICONIFY.DROPDOWN,
  color: '#F5A623',
  hasOptions: true,
  excludeFields: ['inputMode', 'inputRegex'],
  defaults: { answerOptionList: null },
  nodeComponent: DropdownNode,
  configComponent: DropdownConfig,
})
